import React from "react";
import { Button, StyledText } from "../../../../components/common";
import { SuccessBoxIcon } from "../../../../components/svgs";
import { useTheme } from "../../../../hooks";
import { useHistory } from "react-router-dom";
import styled from "styled-components";

const ModalOverlay = styled.div`
  position: absolute;
  z-index: 100;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
`;

const ModalContent = styled.div`
  position: absolute;
  z-index: 100;
  width: 100%;
  bottom: 0;
  box-sizing: border-box;
  padding: 20px 20px;
  height: 55%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: white;
  margin-top: 70%;
  border-top-right-radius: 15px;
  border-top-left-radius: 15px;
`;

const PointsText = styled.span`
  font-family: "MTNBold";
`;

const SurveyCompletonModal = ({ isOpen, onClose }) => {
  const { themeContext, theme } = useTheme();
  const history = useHistory();
  let themeColor = "background";
  let background = theme.colors[themeContext.activeTheme][themeColor];

  if (!isOpen) return null;

  const goToHome = () => {
    const token = JSON.parse(localStorage.getItem("token"));
    history.push(`/home?token=${token}`);
  };

  return (
    <>
      <ModalOverlay onClick={onClose} />
      <ModalContent onClick={(e) => e.stopPropagation()}>
        <StyledText style={{ fontSize: 20, fontWeight: 600 }}>
          Thanks for your feedback
        </StyledText>
        <SuccessBoxIcon width="112" height="112" fill={background} />
        <StyledText
          style={{
            textAlign: "center",
            fontFamily: "MTNRegular",
            paddingInline: 15,
          }}
        >
          Thank you for completing the survey! Your feedback helps us improve
          our services.
        </StyledText>
        <Button
          style={{ backgroundColor: background, width: "80%" }}
          onClick={goToHome}
        >
          <StyledText color="white">Ok</StyledText>
        </Button>
      </ModalContent>
    </>
  );
};

export default SurveyCompletonModal;
